import { PartnerOnboardingEntityRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

/**
 * Mints a login link that skips OTP, reusable until the application expires, so it is a credential: the
 * caller opens it at once and never renders, stores or copies it. A
 * tab opened after an await is usually popup-blocked, so the caller opens a blank tab synchronously in the
 * click handler and points it at the URL once it arrives.
 */
export default function useOpenOnboardingApplication() {
  const [openingOnboardingApplication, setOpeningOnboardingApplication] = useState(false);

  async function openOnboardingApplication(params: PartnerOnboardingEntityRequest) {
    try {
      setOpeningOnboardingApplication(true);
      const res = await api.openPartnerOnboardingApplication(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setOpeningOnboardingApplication(false);
    }
  }

  return { openingOnboardingApplication, openOnboardingApplication };
}
